import 'owl.carousel';

jQuery(document).ready(function() {

    jQuery('.nav-nappi, .toggle-menu li a').on('click', () => {
        jQuery('.nav-nappi').toggleClass('active');
        jQuery('.toggle-menu').toggleClass('visible').toggleClass('hidden');
        jQuery('#main-menu').toggleClass('visible').toggleClass('hidden');
        jQuery('#search-form-nav').toggleClass('hidden').toggleClass('visible');
        jQuery("body").toggleClass('no-scroll');
        jQuery('.nav-logo').toggleClass('white-logo');
    });

    jQuery('.parallax').paroller();
    var options = {
        reset: false,
        delay: 300,
        origin: 'center',
        distance: '100px'
    }
    ScrollReveal().reveal('.reveal', options);
    ScrollReveal().reveal('.reveal-row', { interval: 300 });

    jQuery('.carousel-articles').each(function() {
        jQuery(this).owlCarousel({
            center: true,
            autoWidth:true,
            loop:true,
            margin:30,
            nav:true,
            navText : ['<div class="arrow"><img src="' + templateDir + '/img/arrow.svg" /></div>','<div class="arrow"><img src="' + templateDir + '/img/arrow.svg" /></div>']
        });
    });
});